<template>
  <div class="auth-container">
    <div class="auth-card">
      <!-- 顶部logo和产品信息 -->
      <div class="auth-header">
        <img :src="productInfo.avatar || require('@/assets/default-logo.png')" alt="Logo" class="logo">
        <h1 class="product-name">{{ productInfo.name || '企业认证中心' }}</h1>
        <p class="product-desc">{{ productInfo.description || '安全可靠的企业级身份认证' }}</p>
      </div>

      <!-- 认证方式选项卡 -->
      <el-tabs v-model="activeTab" class="auth-tabs" stretch @tab-click="handleTabChange">
        <!-- 密码登录 -->
        <el-tab-pane label="密码登录" name="password">
          <el-form ref="loginForm" :model="loginForm" :rules="loginRules" label-position="top" class="auth-form">
            <el-form-item label="用户名" prop="username">
              <el-input v-model="loginForm.username" placeholder="请输入用户名" prefix-icon="el-icon-user" />
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input v-model="loginForm.password" type="password" placeholder="请输入密码" prefix-icon="el-icon-lock"
                show-password @keyup.enter.native="handleLogin" />
            </el-form-item>
            <div class="form-actions">
              <el-button type="primary" :loading="loginLoading" @click="handleLogin" class="auth-button">
                登录
              </el-button>
            </div>
            <div class="form-footer">
              <span class="link-text" @click="activeTab = 'code'">验证码登录</span>
              <span class="link-text" @click="activeTab = 'forgot'">忘记密码?</span>
            </div>
          </el-form>
        </el-tab-pane>

        <!-- 验证码登录 -->
        <el-tab-pane label="验证码登录" name="code">
          <el-form ref="codeForm" :model="codeForm" :rules="codeRules" label-position="top" class="auth-form">
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="codeForm.email" placeholder="请输入注册邮箱" prefix-icon="el-icon-message" />
            </el-form-item>
            <el-form-item label="验证码" prop="code">
              <div class="code-input-group">
                <el-input v-model="codeForm.code" placeholder="请输入验证码" prefix-icon="el-icon-key"
                  @keyup.enter.native="handleCodeLogin" />
                <el-button :disabled="codeCountdown > 0" @click="sendCode('login')" class="code-button">
                  {{ codeCountdown > 0 ? `${codeCountdown}秒后重试` : '获取验证码' }}
                </el-button>
              </div>
            </el-form-item>
            <div class="form-actions">
              <el-button type="primary" :loading="codeLoginLoading" @click="handleCodeLogin" class="auth-button">
                登录
              </el-button>
            </div>
            <div class="form-footer">
              <span class="link-text" @click="activeTab = 'password'">密码登录</span>
            </div>
          </el-form>
        </el-tab-pane>

        <!-- 注册 -->
        <el-tab-pane label="注册账号" name="register">
          <el-form ref="registerForm" :model="registerForm" :rules="registerRules" label-position="top"
            class="auth-form">
            <el-form-item label="用户名" prop="username">
              <el-input v-model="registerForm.username" placeholder="请输入用户名" prefix-icon="el-icon-user" />
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="registerForm.email" placeholder="请输入邮箱" prefix-icon="el-icon-message" />
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
              <el-input v-model="registerForm.phone" placeholder="请输入手机号" prefix-icon="el-icon-mobile-phone" />
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input v-model="registerForm.password" type="password" placeholder="请输入密码" prefix-icon="el-icon-lock"
                show-password />
            </el-form-item>
            <el-form-item label="验证码" prop="code">
              <div class="code-input-group">
                <el-input v-model="registerForm.code" placeholder="请输入验证码" prefix-icon="el-icon-key" />
                <el-button :disabled="registerCodeCountdown > 0" @click="sendCode('注册')" class="code-button">
                  {{ registerCodeCountdown > 0 ? `${registerCodeCountdown}秒后重试` : '获取验证码' }}
                </el-button>
              </div>
            </el-form-item>
            <div class="form-actions">
              <el-button type="primary" :loading="registerLoading" @click="handleRegister" class="auth-button">
                注册
              </el-button>
            </div>
            <div class="form-footer">
              <span class="link-text" @click="activeTab = 'password'">已有账号?去登录</span>
            </div>
          </el-form>
        </el-tab-pane>

        <!-- 忘记密码 -->
        <el-tab-pane label="重置密码" name="forgot">
          <el-form ref="forgotForm" :model="forgotForm" :rules="forgotRules" label-position="top" class="auth-form">
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="forgotForm.email" placeholder="请输入注册邮箱" prefix-icon="el-icon-message" />
            </el-form-item>
            <el-form-item label="验证码" prop="code">
              <div class="code-input-group">
                <el-input v-model="forgotForm.code" placeholder="请输入验证码" prefix-icon="el-icon-key" />
                <el-button :disabled="forgotCodeCountdown > 0" @click="sendCode('重置密码')" class="code-button">
                  {{ forgotCodeCountdown > 0 ? `${forgotCodeCountdown}秒后重试` : '获取验证码' }}
                </el-button>
              </div>
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword">
              <el-input v-model="forgotForm.newPassword" type="password" placeholder="请输入新密码" prefix-icon="el-icon-lock"
                show-password />
            </el-form-item>
            <div class="form-actions">
              <el-button type="primary" :loading="resetLoading" @click="handleResetPassword" class="auth-button">
                重置密码
              </el-button>
            </div>
            <div class="form-footer">
              <span class="link-text" @click="activeTab = 'password'">返回登录</span>
            </div>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 页脚 -->
    <div class="global-footer">
      <p>身份认证由<a href="http://auth-id.wanglv.top/#/" target="_blank">Ethan用户中心</a>提供</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import productInfo from '@/utils/product_info'
import { authBaseURL } from '@/utils/axios'
import { setToken } from '@/utils/auth'
import { mapActions } from 'vuex'

import  { initDynamicRoutes } from '../router/index'

export default {
  name: 'AuthCenter',
  data() {
    // 表单验证规则
    const validateEmail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入邮箱地址'))
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        return callback(new Error('请输入有效的邮箱地址'))
      }
      callback()
    }

    return {
      activeTab: 'password',
      productInfo: {},
      // 密码登录表单
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },

      // 验证码登录表单
      codeForm: {
        email: '',
        code: ''
      },
      codeRules: {
        email: [{ validator: validateEmail, trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },

      // 注册表单
      registerForm: {
        username: '',
        email: '',
        phone: '',
        password: '',
        code: ''
      },
      registerRules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        email: [{ validator: validateEmail, trigger: 'blur' }],
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },

      // 忘记密码表单
      forgotForm: {
        email: '',
        code: '',
        newPassword: ''
      },
      forgotRules: {
        email: [{ validator: validateEmail, trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        newPassword: [{ required: true, message: '请输入新密码', trigger: 'blur' }]
      },

      // 加载状态
      loginLoading: false,
      codeLoginLoading: false,
      registerLoading: false,
      resetLoading: false,

      // 验证码倒计时
      codeCountdown: 0,
      registerCodeCountdown: 0,
      forgotCodeCountdown: 0
    }
  },
  mounted() {
    this.fetchProductInfo()
     this.checkAutoLogin()
  },
  methods: {
    ...mapActions(['fetchUserPermissions', 'getInfo']),

    // 获取产品信息
    async fetchProductInfo() {
      try {
        const res = await axios.get(`${authBaseURL}/api/v1/products/info`, {
          params: { product_code: productInfo.ProductCode }
        })
        if (res.data.code === 1) {
          this.productInfo = res.data.data
        }
      } catch (error) {
        console.error('获取产品信息失败:', error)
      }
    },

    // 检查自动登录
    async checkAutoLogin() {
      const token = localStorage.getItem('access_token')
      const refreshToken = localStorage.getItem('refresh_token')
      console.log('自动登录检查，当前token:', token)
      if (token) {
        try {
          let data  = {
            access_token: token,
            refresh_token: refreshToken
          }
          this.handleLoginSuccess(data);
        } catch (error) {
          console.error('自动登录失败:', error)
          localStorage.removeItem('access_token')
        }
      }
    },

    // 选项卡切换
    handleTabChange(tab) {
      // 重置表单验证
      const formRef = this.$refs[`${tab.name}Form`]
      if (formRef) {
        formRef.clearValidate()
      }
    },

    // 密码登录
    async handleLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (!valid) return

        this.loginLoading = true
        try {
          const params = {
            ...this.loginForm,
            product_code: productInfo.ProductCode
          }

          const res = await axios.post(`${authBaseURL}/api/v1/auth/login`, params)
          if (res.data.code === 1) {
            this.handleLoginSuccess(res.data.data)
          } else {
            this.$message.error(res.data.message || '登录失败')
          }
        } catch (error) {
          this.$message.error(error.response.data.message || '登录失败')
        } finally {
          this.loginLoading = false
        }
      })
    },

    // 验证码登录
    async handleCodeLogin() {
      this.$refs.codeForm.validate(async valid => {
        if (!valid) return

        this.codeLoginLoading = true
        try {
          const params = {
            ...this.codeForm,
            product_code: productInfo.ProductCode
          }

          const res = await axios.post(`${authBaseURL}/api/v1/auth/code_login`, params)
          if (res.data.code === 1) {
            this.handleLoginSuccess(res.data.data)
          } else {
            this.$message.error(res.data.message || '登录失败')
          }
        } catch (error) {
          this.$message.error(error.response.data.message || '登录失败')
        } finally {
          this.codeLoginLoading = false
        }
      })
    },

    // 注册
    async handleRegister() {
      this.$refs.registerForm.validate(async valid => {
        if (!valid) return

        this.registerLoading = true
        try {
          const params = {
            ...this.registerForm,
            product_code: productInfo.ProductCode
          }

          const res = await axios.post(`${authBaseURL}/api/v1/auth/register`, params)
          if (res.data.code === 1) {
            this.$message.success('注册成功，请登录')
            this.activeTab = 'password'
            this.$refs.registerForm.resetFields()
          } else {
            this.$message.error(res.data.message || '注册失败')
          }
        } catch (error) {
          this.$message.error(error.response.data.message || '注册失败')
        } finally {
          this.registerLoading = false
        }
      })
    },

    // 重置密码
    async handleResetPassword() {
      this.$refs.forgotForm.validate(async valid => {
        if (!valid) return

        this.resetLoading = true
        try {
          const params = {
            email: this.forgotForm.email,
            code: this.forgotForm.code,
            new_password: this.forgotForm.newPassword,
            product_code: productInfo.ProductCode
          }

          const res = await axios.post(`${authBaseURL}/api/v1/auth/forgot_password`, params)
          if (res.data.code === 1) {
            this.$message.success('密码重置成功，请登录')
            this.activeTab = 'password'
            this.$refs.forgotForm.resetFields()
          } else {
            this.$message.error(res.data.message || '重置失败')
          }
        } catch (error) {
          this.$message.error(error.response.data.message || '重置失败')
        } finally {
          this.resetLoading = false
        }
      })
    },

    // 发送验证码
    async sendCode(scene) {
      let email
      let formRef

      if (scene === '重置密码') {
        email = this.forgotForm.email
        formRef = this.$refs.forgotForm
      } else if (scene === '注册') {
        email = this.registerForm.email
        formRef = this.$refs.registerForm
      } else {
        email = this.codeForm.email
        formRef = this.$refs.codeForm
      }

      // 验证邮箱
      try {
        await formRef.validateField('email')
      } catch (error) {
        return
      }

      try {
        const res = await axios.post(`${authBaseURL}/api/v1/auth/send_code`, {
          email,
          scene
        })

        if (res.data.code === 1) {
          this.$message.success('验证码已发送，请查收')
          // 开始倒计时
          this.startCountdown(scene)
        } else {
          this.$message.error(res.data.message || '发送失败')
        }
      } catch (error) {
        this.$message.error(error.response.data.message || '发送失败')
      }
    },

    // 开始倒计时
    startCountdown(scene) {
      const countdownField = `${scene}CodeCountdown`
      if (this[countdownField] !== undefined) {
        this[countdownField] = 60
        const timer = setInterval(() => {
          this[countdownField]--
          if (this[countdownField] <= 0) {
            clearInterval(timer)
          }
        }, 1000)
      }
    },

    // 登录成功处理
    async handleLoginSuccess(tokenData) {
      
      setToken(tokenData.access_token, tokenData.refresh_token)

      // 验证有效性
      const res = await this.$http.post('/api/auth_token')
      if (res.data.code !== 1) throw new Error(res.data.message)

      this.$message.success('登录成功')

      const permissions = await this.$store.dispatch('fetchUserPermissions')
      await initDynamicRoutes();


      console.log('当前路由表：', this.$router.getRoutes())
      const targetPath = permissions.length > 0 ? `/dashboard/${permissions[0]}` : '/dashboard/profile'
      // 打印调试信息
      console.log('跳转目标：', targetPath, '当前路径：', this.$route.path)

      await this.$router.push(permissions.length > 0 ? '/dashboard/' + permissions[0] : '/dashboard/profile')
    }
  }
}
</script>

<style scoped>
.auth-container {
  height: calc(100vh - 31px);

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f0f2f5;
  padding: 20px;
  box-sizing: border-box;
  /* background-image: url('~@/assets/login-bg.jpg'); */
}

.auth-card {
  width: 100%;
  max-width: 480px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  padding: 40px;
  box-sizing: border-box;
}

.auth-header {
  text-align: center;
  margin-bottom: 30px;
}

.auth-header .logo {
  width: 80px;
  height: 80px;
  margin-bottom: 16px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid #f0f0f0;
}

.auth-header .product-name {
  font-size: 24px;
  color: #333;
  margin: 0 0 8px 0;
  font-weight: 600;
}

.auth-header .product-desc {
  font-size: 14px;
  color: #666;
  margin: 0;
}

.auth-tabs>>>.el-tabs__nav-wrap::after {
  height: 1px;
  background-color: #e8e8e8;
}

.auth-tabs>>>.el-tabs__active-bar {
  height: 3px;
  border-radius: 3px 3px 0 0;
}

.auth-tabs>>>.el-tabs__item {
  font-size: 16px;
  padding: 0 20px;
  height: 48px;
  line-height: 48px;
}

.auth-form {
  margin-top: 20px;
}

.auth-form>>>.el-form-item__label {
  padding: 0;
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

.auth-form>>>.el-input__inner {
  height: 44px;
  line-height: 44px;
  border-radius: 4px;
}

.code-input-group {
  display: flex;
  gap: 10px;
}

.code-input-group>>>.el-input {
  flex: 1;
}

.code-input-group .code-button {
  width: 120px;
  padding: 0;
}

.form-actions {
  margin-top: 30px;
}

.form-actions .auth-button {
  width: 100%;
  height: 44px;
  border-radius: 4px;
  font-size: 16px;
}

.form-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  font-size: 14px;
}

.form-footer .link-text {
  color: #1890ff;
  cursor: pointer;
  transition: color 0.3s;
}

.form-footer .link-text:hover {
  color: #40a9ff;
}

.global-footer {
  margin-top: 30px;
  text-align: center;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
</style>


// WEBPACK FOOTER //
// src/components/AuthCenter.vue